import { I18n } from "@assets/strings";
import React from "react";
import { useLocation } from "react-router";
import { useHistory } from "@core/routing/useHistory";
import styled, { css } from "styled-components";
import { Path } from "@core/routing/path";
import { useServices } from "@core/servicesContext";
import { Group } from "@domain/group/group";
import { theme } from "@ui/styles/theme";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { CommunityIcon, ExploreIcon } from "@ui/components/icons";
import { row } from "@ui/components/layout";

interface DiscoverShareroomThumbnailButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
	shareroom: Group;
}

export const DiscoverShareroomThumbnailButton: React.FC<DiscoverShareroomThumbnailButtonProps> = ({
	shareroom,
	...htmlProps
}) => {
	const isMember = shareroom.userRole === "MEMBER";
	const isAdmin = shareroom.userRole === "ADMINISTRATOR" && shareroom.status === "VALIDATED";
	const disabledButton = isMember || isAdmin;

	const history = useHistory();
	const { pathname } = useLocation();
	const { trackingService } = useServices();

	return (
		<Container
			{...htmlProps}
			buttonType={disabledButton ? "default" : "primary"}
			hoverDisabled={disabledButton}
			onClick={() => {
				if (pathname === "/") trackingService.track("User_Discover classroom_Feed");
				if (pathname === "/search") trackingService.track("User_Discover classroom_Explorer");

				history.push(Path.Shareroom(shareroom));
			}}
		>
			{isAdmin || isMember ? (
				<CommunityIcon color={theme.colors.darkgray} width={18} />
			) : (
				<ExploreIcon color={theme.colors.white} width="23" height="16" />
			)}
			<span>
				{isAdmin || isMember
					? I18n.t(`group.${shareroom.type}.indicative_role.${shareroom.userRole}`)
					: I18n.t("discover")}
			</span>
		</Container>
	);
};

const Container = styled(LoadingButton)<{ hoverDisabled?: boolean }>`
	padding: 4px 9px;
	${row(5, "flex-start", "center")};
	min-width: 50px;
	border-radius: 4px;
	${({ hoverDisabled }) =>
		hoverDisabled &&
		css`
			:hover {
				background-color: ${({ theme }) => theme.colors.lightergray};
			}
		`}

	span {
		font-size: 0.8125rem;
		font-weight: 600;
	}

	> svg {
		fill: #fff;
	}
`;
